export function currentBankLedger(order) {
  const version = Number(order.conditions_version || 0);
  const receipts = (order.bankPaymentReceipts || []).filter((entry) => Number(entry.conditions_version) === version);
  const adjustments = (order.bankPaymentAdjustments || []).filter((entry) => Number(entry.conditions_version) === version);
  const receivedCents = receipts.reduce((sum, entry) => sum + Number(entry.amount_cents || 0), 0);
  const refundedCents = adjustments.filter((entry) => entry.kind === "refund").reduce((sum, entry) => sum + Number(entry.amount_cents || 0), 0);
  const correctedCents = adjustments.filter((entry) => entry.kind === "correction").reduce((sum, entry) => sum + Number(entry.amount_cents || 0), 0);
  return { receipts, adjustments, receivedCents, refundedCents, correctedCents, netCents: receivedCents - refundedCents - correctedCents };
}

export function bankTermsAreLocked(order, netCents) {
  return Boolean(order.payment_review_required)
    || order.payment_status === "paid"
    || ((order.bankPaymentReceipts || []).some((entry) => Number(entry.conditions_version) === Number(order.conditions_version)) && netCents !== 0);
}
